exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".damgage-location {\n  position: relative;\n}\n\n#damage_img {\n  display: none;\n}\n\n#damgage_effect_canvas {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\topacity: 0.5;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/utilities/damage-location/damage-location.component.css
// module id = ../../../../../src/app/utilities/damage-location/damage-location.component.css
// module chunks = main